export enum CuratedListType {
  FEATURED = 'FEATURED',
  PERK = 'PERK',
  REGULAR = 'REGULAR',
}

export enum CuratedListTypeName {
  FEATURED = 'Featured',
  PERK = 'Perk',
  REGULAR = 'Regular',
}

export enum CuratedListEvent {
  CREATED = 'CURATED_LIST_CREATED',
  UPDATED = 'CURATED_LIST_UPDATED',
  DELETED = 'CURATED_LIST_DELETED',
}

export enum CuratedListItemType {
  VENUE = 'VENUE',
  EVENT = 'EVENT',
}

export enum CuratedListTypeName {
  VENUE = 'Venue',
  EVENT = 'Event',
}

export enum CuratedListActionType {
  UPDATE_SORT = 'UPDATE_SORT',
}

export enum CuratedListItemActionType {
  UPDATE_SORT = 'UPDATE_SORT',
}

export enum CuratedListNotificationType {
  PUSH = 'PUSH',
}

export enum CuratedListNotificationTypeName {
  PUSH = 'Push',
}

export enum CuratedListErrorMessage {
  CURATED_LIST_NOT_FOUND = 'curated list not found',
  CITY_IS_REQUIRED = 'city is required',
  VENUE_NOT_FOUND = 'venue not found',
  EVENT_NOT_FOUND = 'event not found',
  CURATED_LIST_IS_REQUIRED = 'curated list is required',
  SORT_IS_REQUIRED = 'sort is required',
  TITLE_IS_REQUIRED = 'title is required',
  DESCRIPTION_IS_REQUIRED = 'description is required',
  IMAGE_URL_IS_REQUIRED = 'imageUrl is required',
  IMAGE_URL_IS_INVALID = 'imageUrl is invalid',
  TYPE_IS_REQUIRED = 'type is required',
  TYPE_IS_INVALID = 'type is invalid',
  AUTHOR_IMAGE_URL_IS_INVALID = 'authorImageUrl is invalid',
  THUMBNAIL_IMAGE_URL_IS_INVALID = 'thumbnailImageUrl is invalid',
  ENABLE_MUST_BE_A_BOOLEAN = 'enable must be a boolean',
  ENABLE_START_MUST_BE_A_DATE = 'enableStart must be a date',
  ENABLE_END_MUST_BE_A_DATE = 'enableEnd must be a date',
  ENABLE_START_MUST_BE_BEFORE_ENABLE_END = 'enableStart must be before enableEnd',
  MEMBERSHIP_LEVEL_MUST_BE_A_NUMBER = 'membershipLevel must be a number',
  CITY_DOES_NOT_EXIST = 'city does not exist',
}

export enum CuratedListItemErrorMessage {
  CURATED_LIST_ITEM_NOT_FOUND = 'curated list item not found',
  CURATED_LIST_NOT_FOUND = 'curated list not found',
  VENUE_NOT_FOUND = 'venue not found',
  EVENT_NOT_FOUND = 'event not found',
  CURATED_LIST_IS_REQUIRED = 'curatedList is required',
  TITLE_MUST_BE_A_STRING = 'title must be a string',
  DESCRIPTION_MUST_BE_A_STRING = 'description must be a string',
  IMAGE_URL_IS_INVALID = 'imageUrl is invalid',
  ENABLE_START_MUST_BE_A_DATE = 'enableStart must be a date',
  ENABLE_END_MUST_BE_A_DATE = 'enableEnd must be a date',
  ENABLE_START_MUST_BE_BEFORE_ENABLE_END = 'enableStart must be before enableEnd',
  ENABLE_MUST_BE_A_BOOLEAN = 'enable must be a boolean',
  VENUE_IS_REQUIRED = 'venue is required',
  TYPE_IS_REQUIRED = 'type is required',
  TYPE_IS_INVALID = 'type is invalid',
  DATE_MUST_BE_A_DATE = 'date must be a date',
  LINK_IS_REQUIRED = 'link is required',
  LINK_TYPE_IS_REQUIRED = 'link.type is required',
  EVENT_IS_REQUIRED_FOR_EVENT_TYPE = 'event is required for EVENT type',
  SORT_IS_REQUIRED = 'sort is required',
}

export enum CuratedListItemEvent {
  CREATED = 'CURATED_LIST_ITEM_CREATED',
  UPDATED = 'CURATED_LIST_ITEM_UPDATED',
  DELETED = 'CURATED_LIST_ITEM_DELETED',
}
